import { render, staticRenderFns } from "./TPassDirections.vue?vue&type=template&id=2836fb00&"
import script from "./TPassDirections.vue?vue&type=script&lang=js&"
export * from "./TPassDirections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports